fx.ns("models", class ProductCalendarPage extends  models.CreationElement {

	constructor(data)
	{
		super(data);
	}
    
    addComponent(data, side, width, height, layout) 
    {
        data.creation_element_id = this.id;

        // background is a special case :
        if (data.component_type == "background") 
        {
            let background = this.getBackground(data.side);

            if (!background) {
                this.addBackground(data.side);
                background = this.getBackground(data.side);
            }

            if (background)
                background.update({ content: data.content, bgcolor: data.bgcolor });

        }
        else // sticker / photo /shape / text / other
        {
            // For text, set position and check background color so we can set text color to opposite
            if (data.component_type == "text") {
                if (!layout && data.x === undefined) {
                    data.x = (width - data.width) / 2;
                    data.y = (height - data.height) / 2;
                }

                // Change text color depending on background color
                if (!layout) 
                {
                    let color = "#ffffff";
                    let background = this.getBackground(data.side);

                    // Temporary fix : case when some background is missing :(
                    if (!background) {
                        this.addBackground(data.side);
                        background = this.getBackground(data.side);
                    }

                    color = (background.content ? background.text_color : background.bgcolor); // we store in text_color the average color of the background image
                    color = tinycolor(color);

                    if (color.toRgbString() == data.text_color) {
                        if (color.isDark())
                            color.brighten(color.getBrightness() > 20 ? 40 : 90);
                        else
                            color.darken(color.getBrightness() > 240 ? 70 : 20);

                        data.content = data.content.replace(/rgb\((\d+),\s(\d+),\s(\d+)\)/g, color.toRgbString());
                        data.text_color = color.toRgbString(); //"#ffffff";

                    }
                }


            }
            else
            if (data.component_type == "photo" && data.x === undefined) // added without position, need to be centered
            {
                data.x = (width - data.width) / 2;
                data.y = (height - data.height) / 2;
            }

            data.id = Utils.newID();
            data.level = this.maxLevel + 1;

            let index = this.components.length;

            /*if (data.component_type == "photo") 
            {
                for (let i = 0; i < this.components.length; i++) {
                    if (this.components.getItemAt(i).component_type == "background")
                        index = i;
                }
            }*/

            let component = new models.CreationElementContent(data);
            component.level = index + 1;

            for (let i = index + 1; i < this.components.length; i++)
                this.components.getItemAt(i).level++;

            this.components.addItemAt(index + 1, component);
        }
    }

    addBackground(side) {
        
        let background = this.getBackground(side);

        if (!background)
        {
            background = new models.CreationElementContent({ creation_element_id: this.id, creation: side, component_type: "background", bgcolor: this.bgcolorleft, align: "" })
            this.components.addItemAt(0, background);
        }

        return background;
    }


    updateBackgroundColor(color, side) 
    {
        side = typeof side == "string" ? side : undefined;
        
        let bg = this.getBackground(side);

        if (!bg)
            bg = this.addBackground(side)

        if (bg)
            bg.update({ content: "", bgcolor: color });

        this.bgcolor = color;
    }


      

      applyLayout(layout, width, height, keepDesign, side) 
      {
         this._photoContents = this._photoContents.filter(function (component) {
            return component.content != "";
        });

        // 1 - Remove all component, except backgrounds
        let existingComponents = this.components.toArray();

        while (existingComponents.length > 0) 
        {
            let component = existingComponents.pop();

            let bounding = fx.graphics.getBoundingRect(component, component.rotation);
            let valid = true;

            if (side == "bottom")
                valid = bounding.y >= height;
            
            if (valid && component.isPhoto && component.content != "" && this._photoContents.find({ content: component.content }) == null)
                this._photoContents.unshift(component);

            if (valid && !component.isBackground && !component.isCalendar) // let's test also if need to delete all component, or only component from one side
            {
                if (!keepDesign || component.isPhoto || component.isSticker || component.isShape)
                    component.delete();
            }

        }

        let layoutBackground = layout.getBackground();
        let bg = this.getBackground(side == "bottom" ? side : undefined);

        // temporary fix
        let emptyBG = this.getBackground("");
        if (emptyBG)
            emptyBG.delete();

         if (!bg) 
        {
            this.addBackground(side == "bottom" ? side : undefined);
            bg = this.getBackground(side == "bottom" ? side : undefined);
        }

        if (bg)
            bg.update({ content: layoutBackground ? layoutBackground.content : "", bgcolor: layoutBackground ? layoutBackground.bgcolor : ""});
            
       
        for (let i = 0; i < layout.components.length; i++)
        {
            let layoutComponent = layout.components.getItemAt(i).JSON();

            if (layoutComponent.component_type != "background") {
                if (layoutComponent.component_type == "photo")
                    layoutComponent.content = "";

                if( side == "bottom")
                    layoutComponent.y += height;
                
                this.addComponent(layoutComponent, "", width, height, true, keepDesign);
            }
        }


        // ---> SET PHOTOS content
        // sort photoContent from left to right, and components from left to right
        // and then apply content

        let components = this.components.filter(function (component) {
            return component.isPhoto && !component.deleted;
        });


        this._photoContents.sort(function (a, b) {
            let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
            let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
            return bounding1.x - bounding2.x;
        })

        components.sort(function (a, b) {
            let bounding1 = fx.graphics.getBoundingRect(a, a.rotation);
            let bounding2 = fx.graphics.getBoundingRect(b, b.rotation);
            return bounding1.x - bounding2.x;
        })

        let index = 0;
        for (let i = 0; i < components.length && index < this._photoContents.length; i++) {
            let photoContent = this._photoContents[index];

            let tempId = Utils.temporaryId(photoContent.content);
            components[i].content = tempId ? tempId : photoContent.content;
            index++;
        }

        this.delay(this._cleanPhotoContent, 30000);
      }
	

      getBackground(side) {
        
        let bg;
        for (let i = 0; i < this.components.length; i++) {
            let component = this.components.getItemAt(i);

            // fix for a bug from config
            if (component.creation == "0")
                component.creation = "";
            
            if (!component.deleted && component.isBackground && component.creation == side) {
                bg = component;
                break;
            }
        }

        return bg;
    }
	
});
